import { motion } from "framer-motion";
import { ArrowRight, MessageCircle, Ship, ShieldCheck, Clock } from "lucide-react";
import { HERO_IMG } from "../../data/site";
import { WHATSAPP_LINK } from "../../lib/api";
import { FlagPair } from "../Brand";
import { useContent } from "../../context/ContentContext";

const STAT_ICONS = [Ship, ShieldCheck, Clock];

export const Hero = () => {
  const { hero } = useContent();
  return (
    <section id="home" className="relative min-h-screen overflow-hidden" data-testid="hero-section">
      <img src={HERO_IMG} alt="Cargo ship" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-navy-900/90 via-navy/75 to-navy/40" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(217,164,65,0.15),transparent_55%)]" />

      <div className="relative mx-auto flex min-h-screen max-w-7xl flex-col justify-center px-4 pb-32 pt-28 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl"
        >
          <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-white backdrop-blur">
            <FlagPair /> {hero.badge}
          </span>

          <h1 className="mt-6 font-display text-4xl font-black leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
            {hero.title} <span className="text-gold">{hero.titleHighlight}</span>
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/80">{hero.subtitle}</p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <a
              href="#quote"
              data-testid="hero-quote-btn"
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-brandred px-7 py-4 text-base font-bold text-white shadow-lg shadow-brandred/30 transition-transform hover:bg-brandred-700 active:scale-95"
            >
              {hero.primaryCta} <ArrowRight size={18} />
            </a>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noreferrer"
              data-testid="hero-whatsapp-btn"
              className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/30 bg-white/10 px-7 py-4 text-base font-bold text-white backdrop-blur transition-colors hover:bg-white/20"
            >
              <MessageCircle size={18} /> {hero.secondaryCta}
            </a>
          </div>

          <div className="mt-12 grid max-w-lg grid-cols-3 gap-4">
            {hero.stats.map((s, i) => {
              const Icon = STAT_ICONS[i % STAT_ICONS.length];
              return (
                <div key={s.label} className="rounded-xl border border-white/10 bg-white/5 px-4 py-4 backdrop-blur">
                  <Icon className="h-5 w-5 text-gold" />
                  <p className="mt-2 font-display text-xl font-black text-white">{s.value}</p>
                  <p className="text-xs text-white/60">{s.label}</p>
                </div>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
